function initSwiper() {
  const isMobile = window.innerWidth <= 749;
  const swiperContainer = document.querySelector('.swiper-container');
  
  if (isMobile) {
    swiperContainer.classList.remove('swiper-container');
    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    wrapper.style.display = 'block';
    wrapper.style.height = 'auto';
    const slides = wrapper.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      slide.style.height = 'auto';
      slide.style.opacity = '1';
    });
    const progressBars = document.querySelector('.progress-bars-container');
    if (progressBars) {
      progressBars.style.display = 'none';
    }
  } else {
    var mySwiper = new Swiper(".swiper-container", {
      direction: "vertical",
      loop: true,
      speed: 2000,
      parallax: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        waitForTransition: true
      },
      effect: "slide",
      allowTouchMove: false,
      watchSlidesProgress: true,
      on: {
        init: function() {
          const progressBars = document.querySelectorAll('.progress-bar');
          progressBars.forEach(bar => {
            bar.classList.remove('active');
          });
          const realIndex = this.realIndex;
          progressBars[realIndex].classList.add('active', 'first-load');
        },
        slideChange: function() {
          const progressBars = document.querySelectorAll('.progress-bar');
          const realIndex = this.realIndex;
          
          progressBars.forEach(bar => {
            bar.classList.remove('active', 'first-load');
          });
          
          progressBars[realIndex].classList.add('active');
        }
      }
    });
  }
}
initSwiper();

window.addEventListener('resize', initSwiper);